import { render, staticRenderFns } from "./QuickResponseChatPopUp.vue?vue&type=template&id=5be730d0&scoped=true&"
import script from "./QuickResponseChatPopUp.vue?vue&type=script&lang=js&"
export * from "./QuickResponseChatPopUp.vue?vue&type=script&lang=js&"
import style0 from "./QuickResponseChatPopUp.vue?vue&type=style&index=0&id=5be730d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be730d0",
  null
  
)

export default component.exports